async function removeBundleItems() {
  try {
    // Step 1: Fetch the current cart
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const cart = await response.json();

    // Step 2: Filter items with _bundle_item: "true"
    const itemsToRemove = cart.items.filter(item => 
      item.properties && item.properties._bundle_item === "true"
    );

    if (itemsToRemove.length === 0) {
      console.log('No bundle items found in the cart.');
      return;
    }

    // Step 3: Prepare update payload to set quantities to 0
    const updates = {};
    itemsToRemove.forEach(item => {
      updates[item.variant_id] = 0; // Set quantity to 0 to remove
    });

    // Step 4: Update the cart
    const updateResponse = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    });
    const updatedCart = await updateResponse.json();
    setTimeout(() => {
      openCartDrawer();
    }, 50);

    console.log('Bundle items removed:', updatedCart);
    // Optionally, update the UI or reload the cart
    console.log('Bundle items have been removed from your cart!');
  } catch (error) {
    console.error('Error removing bundle items:', error);
    console.log('Failed to remove bundle items. Please try again.');
  }
}

async function openCartDrawer() {
    console.log("Starting openCartDrawer...");

    try {
        // Fetch cart data and sections
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();

        const sectionsUrl = `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count`;
        const sectionsResponse = await fetch(sectionsUrl);
        const sectionsData = await sectionsResponse.json();

        console.log("Cart data:", cartData);
        console.log("Sections data:", sectionsData);

        // Update cart count
        if (window.Alpine && window.Alpine.store("cart_count")) {
        window.Alpine.store("cart_count").count = cartData.item_count;
        }

        if (window.theme) {
        window.theme.cartItemCount = cartData.item_count;
        }

        // Open cart drawer first
        if (window.Alpine && window.Alpine.store("modals")) {
        window.Alpine.store("modals").open("cart");

        // Wait for drawer to open, then update content
        setTimeout(() => {
            console.log("Updating cart drawer content...");

            // Update cart items
            if (sectionsData["cart-items"]) {
            const cartItemsContainer =
                document.querySelector("[data-cart-items]");
            if (cartItemsContainer) {
                const parser = new DOMParser();
                const newContent = parser.parseFromString(
                sectionsData["cart-items"],
                "text/html"
                );
                const newCartItems = newContent.querySelector("[data-cart-items]");

                if (newCartItems) {
                cartItemsContainer.innerHTML = newCartItems.innerHTML;

                // Re-initialize Alpine.js on updated content
                if (window.Alpine) {
                    window.Alpine.initTree(cartItemsContainer);
                }
                console.log("Cart items updated");
                }
            }
            }

            // Update cart footer
            if (sectionsData["cart-footer"]) {
            const cartFooterContainer =
                document.querySelector("[data-cart-footer]");
            if (cartFooterContainer) {
                const parser = new DOMParser();
                const newContent = parser.parseFromString(
                sectionsData["cart-footer"],
                "text/html"
                );
                const newCartFooter =
                newContent.querySelector("[data-cart-footer]");

                if (newCartFooter) {
                cartFooterContainer.innerHTML = newCartFooter.innerHTML;

                // Re-initialize Alpine.js on updated content
                if (window.Alpine) {
                    window.Alpine.initTree(cartFooterContainer);
                }
                console.log("Cart footer updated");
                }
            }
            }
        }, 300); // Wait for drawer animation
        }

        console.log("Cart drawer opened successfully");
        return cartData;
    } catch (error) {
        console.error("Error in openCartDrawer:", error);

        // Fallback: simple cart open
        if (window.Alpine && window.Alpine.store("modals")) {
        window.Alpine.store("modals").open("cart");
        } else {
        // Ultimate fallback - redirect to cart page
        window.location.href = "/cart";
        }
    }
}